import { motion, useReducedMotion } from 'motion/react';
import { ArrowRight } from 'lucide-react';
import HeroShowcase from './HeroShowcase';

const FOCUS_RING = 'focus-visible:focus-ring';

const group = { hidden: {}, visible: { transition: { staggerChildren: 0.1 } } };
const item = {
  hidden: { opacity: 0, filter: 'blur(12px)', y: 12 },
  visible: {
    opacity: 1,
    filter: 'blur(0px)',
    y: 0,
    transition: { type: 'spring', bounce: 0.3, duration: 1.5 },
  },
};

/** L'apertura della landing: titolo, sottotitolo e vetrina del prodotto. */
export function HeroSection() {
  const reduceMotion = useReducedMotion();
  const enter = reduceMotion ? {} : { initial: 'hidden', animate: 'visible', variants: group };
  const child = reduceMotion ? {} : { variants: item };

  return (
    <section
      id="piattaforma"
      className="relative min-h-screen overflow-hidden pt-20 text-strong md:pt-24"
    >
      <motion.div {...enter} className="mx-auto max-w-7xl px-6 text-center">
        <motion.div {...child}>
          <a
            href="#moduli"
            className={`mx-auto flex w-fit items-center gap-3 rounded-full border border-default bg-muted py-1 pl-4 pr-1 shadow-resting transition-colors duration-150 hover:bg-default ${FOCUS_RING}`}
          >
            <span className="flex items-center gap-2 text-sm text-strong">
              <span aria-hidden className="inline-block size-1.5 rounded-full bg-brand" />
              Cloud-native SaaS per flotte operative reali
            </span>
            <span aria-hidden className="block h-4 w-px bg-strong" />
            <span className="text-caption font-medium text-link">Scopri i moduli</span>
            <span className="flex size-6 items-center justify-center rounded-full bg-default">
              <ArrowRight aria-hidden className="size-3 text-link" />
            </span>
          </a>
        </motion.div>
        <motion.h1
          {...child}
          className="mx-auto mt-8 max-w-4xl text-balance text-5xl font-semibold tracking-tight md:text-7xl lg:mt-16"
        >
          <span className="block">Tutta la flotta operativa,</span>
          <span className="mt-2 block text-brand">sotto controllo</span>
        </motion.h1>
        <motion.p {...child} className="mx-auto mt-8 max-w-2xl text-balance text-lg text-subtle">
          MovoFleet centralizza tracking, manutenzioni, costi, documenti e alert in un&apos;unica
          Operations Room. Workflow più semplici, dati più leggibili, decisioni più rapide.
        </motion.p>
      </motion.div>
      <HeroShowcase />
    </section>
  );
}
